<nav class="prf-header-dropdown-menu prf-header-dropdown-menu-opened">
  <ul>
    @for (item of navItems; track item.id) {
      <prf-header-dropdown-menu-item [linkHref]="item.href" [linkText]="item.linkText" [ymGoal]="item.ymGoal" />
    }

    <prf-header-dropdown-menu-item [linkHref]="specialNavItem.href" [linkText]="specialNavItem.linkText" [isSpecial]="true" [ymGoal]="specialNavItem.ymGoal" />
  </ul>
</nav>
